module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "TOC-Title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "chapImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/chapicon.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent1"
  }, [_c('a', {
    attrs: {
      "href": "#/006_acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent1"
  }, [_c('a', {
    attrs: {
      "href": "#/007_introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('a', {
    attrs: {
      "href": "#/008_ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _vm._v(" Carlisle before August 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('a', {
    attrs: {
      "href": "#/011_ch02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _vm._v(" 1914 July: Last days of normality")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('a', {
    attrs: {
      "href": "#/012_ch03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _vm._v(" 1914 August to December: Over by Christmas?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/026_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _vm._v(" 1915: War Comes to Carlisle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/074_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _vm._v(" 1916: Social Changes and Military Losses")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/107_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _vm._v(" 1917: War Routines, Local Services")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/151_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _vm._v(" 1918: Turmoil and Triumph")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/173_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _vm._v(" Afterword, 1919 and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_paraNoIndent1"
  }, [_c('span', {
    attrs: {
      "href": "#/183_bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7092563c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_toc.vue
// module id = 66
// module chunks = 0